import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const PolicySection = ({ id, title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div id={id} className="border-b" style={{ borderColor: 'rgba(13,33,55,0.1)' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-5 text-left group"
      >
        <h2 className="text-lg font-semibold" style={{ color: '#0D2137' }}>{title}</h2>
        <ChevronDown
          size={20}
          style={{
            color: '#E8732A',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.25s ease'
          }}
        />
      </button>
      {isOpen && (
        <div className="pb-6 space-y-3" style={{ color: '#4B5563', lineHeight: '1.75' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default PolicySection;
